module.exports = __webpack_public_path__ + "img/筆記裝飾_月亮_手機.1acd30d7.svg";